/* ==========================================================================
   ILL.SIG — secret landing page.
   Everything moves on anime.js v4 and its utilities:
   random · randomPick · shuffle · createSeededRandom · wrap · clamp · mapRange
   lerp · damp · snap · round · padStart · padEnd · degToRad · stagger (grid)
   get · set · cleanInlineStyles · $
   ========================================================================== */
(function () {
  'use strict';

  var H = document.documentElement;
  var root = document.querySelector('[data-ill-root]');
  if (!root) return;

  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var GLYPHS = 'ILLSIG01<>/\\|[]{}#%$&*+=:;?!'.split('').concat(['▓', '▒', '░', '█', '▌', '▐', '■', '◊', '×', '†']);
  var MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  var store = {
    get: function () { try { return window.sessionStorage.getItem('ill-in') === '1'; } catch (e) { return false; } },
    set: function () { try { window.sessionStorage.setItem('ill-in', '1'); } catch (e) { /* private mode */ } }
  };

  function whenAnime(fn) {
    if (window.anime) return fn();
    var n = 0, t = setInterval(function () {
      if (window.anime || ++n > 150) {
        clearInterval(t);
        if (window.anime) fn();
        else H.classList.add('ill-in'); // library blocked: just show the goods
      }
    }, 40);
  }

  whenAnime(function () {
    var A = window.anime, u = A.utils;
    var $ = function (sel, ctx) { return u.$(sel).filter(function (el) { return !ctx || ctx.contains(el); }); };
    var one = function (sel) { return root.querySelector(sel); };
    var pad = function (n, len) { return u.padStart(String(n), len || 2, '0'); };
    var hex = function (n, len) { return u.padStart(Math.floor(n).toString(16).toUpperCase(), len || 4, '0'); };
    var daySeed = (function () { var d = new Date(); return d.getUTCFullYear() * 1000 + d.getUTCMonth() * 40 + d.getUTCDate(); })();
    var rnd = u.createSeededRandom(daySeed); // same "node" all day, new one tomorrow

    /* ---------- tiny scramble helper (randomPick glyphs, resolves left→right or shuffled) ---------- */
    function scramble(el, finalText, opts) {
      opts = opts || {};
      if (!el) return;
      var text = finalText == null ? el.textContent : finalText;
      if (reduce) { el.textContent = text; return; }
      var chars = text.split('');
      var order = opts.shuffled ? u.shuffle(chars.map(function (_, i) { return i; })) : chars.map(function (_, i) { return i; });
      var done = {}, step = 0, per = opts.speed || 2;
      clearInterval(el._illScr);
      el._illScr = setInterval(function () {
        for (var k = 0; k < per && step < order.length; k++) done[order[step++]] = true;
        el.textContent = chars.map(function (c, i) { return done[i] || c === ' ' ? c : u.randomPick(GLYPHS); }).join('');
        if (step >= order.length) { clearInterval(el._illScr); el.textContent = text; if (opts.done) opts.done(); }
      }, opts.tick || 32);
    }

    /* ---------- clock: date-time group, zero padded ---------- */
    function clock() {
      var d = new Date();
      var s = pad(d.getUTCDate()) + pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + 'Z ' + MON[d.getUTCMonth()] + ' ' + pad(d.getUTCFullYear() % 100);
      $('[data-ill-clock]').forEach(function (el) { el.textContent = reduce ? s : s + ' +' + pad(d.getUTCSeconds()); });
      setTimeout(clock, 1000 - d.getMilliseconds());
    }
    clock();
    var nodeId = pad(rnd(1, 999), 3) + '-' + hex(rnd(0, 65535));
    $('[data-ill-node]').forEach(function (el) { el.textContent = nodeId; });

    /* ---------- glyph rain (wrap keeps every column looping forever) ---------- */
    (function rain() {
      var cv = one('[data-ill-rain]');
      if (!cv) return;
      var ctx = cv.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1);
      var cell = 16, cols = [], w = 0, h = 0, rows = 0, last = 0;
      var acid = getComputedStyle(root).getPropertyValue('--ill-acid').trim() || '#D4FF3A';
      function size() {
        w = window.innerWidth; h = window.innerHeight;
        cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.font = '500 13px "ILL Mono", monospace';
        rows = Math.ceil(h / cell);
        var n = Math.ceil(w / cell);
        cols = [];
        for (var i = 0; i < n; i++) cols.push({ y: u.random(-rows, rows), v: u.random(4, 16, 2), on: Math.random() < 0.55 });
      }
      function draw(t) {
        requestAnimationFrame(draw);
        if (document.hidden || t - last < 42) return; // ~24fps is plenty for rain
        step(Math.min(100, t - (last || t))); last = t;
      }
      function step(dt) {
        ctx.fillStyle = 'rgba(5,5,6,0.2)';
        ctx.fillRect(0, 0, w, h);
        for (var i = 0; i < cols.length; i++) {
          var c = cols[i];
          if (!c.on) continue;
          c.y = u.wrap(c.y + c.v * dt / 1000, -8, rows + 8);
          var y = Math.floor(c.y) * cell;
          ctx.fillStyle = Math.random() < 0.08 ? '#ffffff' : acid;
          ctx.globalAlpha = u.random(0.35, 0.9, 2);
          ctx.fillText(u.randomPick(GLYPHS), i * cell, y);
        }
        ctx.globalAlpha = 1;
      }
      size();
      window.addEventListener('resize', size);
      if (reduce) {
        for (var k = 0; k < 40; k++) step(60); // one still frame of rain
        return;
      }
      requestAnimationFrame(draw);
    })();

    /* ---------- the gate ---------- */
    var gate = one('[data-ill-gate]');
    var frame = gate && gate.querySelector('.ill-gate__frame');
    var mark = gate && gate.querySelector('[data-ill-mark]');
    var entered = false;

    function glitchVars(el, amt) {
      if (!el) return;
      el.style.setProperty('--ill-gx', u.random(-amt, amt) + 'px');
      el.style.setProperty('--ill-rx', u.random(-amt, amt) + 'px');
      var a = u.random(0, 70), b = u.random(0, 70);
      el.style.setProperty('--ill-c1', a + '%'); el.style.setProperty('--ill-c2', u.clamp(90 - a - u.random(4, 20), 0, 96) + '%');
      el.style.setProperty('--ill-c3', b + '%'); el.style.setProperty('--ill-c4', u.clamp(90 - b - u.random(4, 20), 0, 96) + '%');
    }
    function idleGlitch() {
      if (entered || reduce || !mark) return;
      glitchVars(mark, 7);
      setTimeout(function () { glitchVars(mark, 2); }, 90);
      setTimeout(idleGlitch, u.random(700, 2600));
    }

    function typeLog() {
      var out = one('[data-ill-log]'), src = one('[data-ill-log-src]');
      if (!out || !src) return;
      var ip = [u.random(10, 223), u.random(0, 255), u.random(0, 255), u.random(1, 254)].join('.');
      var lines = (src.innerHTML || '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'")
        .split('\n').map(function (l) { return l.trim(); }).filter(Boolean)
        .map(function (l) {
          return '> ' + l.replace(/\{HEX\}/g, hex(u.random(0, 65535)) + ':' + hex(u.random(0, 65535)))
            .replace(/\{IP\}/g, ip).replace(/\{NODE\}/g, nodeId).replace(/\{PCT\}/g, '{PCT}');
        });
      var esc = function (s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
      var hi = function (s) { return esc(s).replace(/(\bOK\b|ILLICIT|\d{2,3}%)/g, '<em>$1</em>'); };
      var li = 0;
      function nextLine() {
        if (li >= lines.length || entered) return;
        var line = document.createElement('div'); out.appendChild(line);
        var text = lines[li++];
        if (text.indexOf('{PCT}') > -1) { // live percentage that counts up with a snapped step
          var o = { v: 0 };
          A.animate(o, {
            v: 100, duration: reduce ? 0 : 1400, ease: 'inOutQuad',
            onUpdate: function () { line.innerHTML = hi(text.replace('{PCT}', pad(u.snap(o.v, 4) | 0, 3))); },
            onComplete: function () { line.innerHTML = hi(text.replace('{PCT}', '100')); setTimeout(nextLine, 160); }
          });
          return;
        }
        if (reduce) { line.innerHTML = hi(text); return nextLine(); }
        var i = 0;
        (function typeChar() {
          if (entered) return;
          i = Math.min(text.length, i + (text.charAt(i) === '.' ? 1 : u.random(1, 3)));
          line.textContent = text.slice(0, i) + (i < text.length ? '█' : '');
          if (i < text.length) setTimeout(typeChar, text.charAt(i) === '.' ? u.random(40, 110) : u.random(10, 28));
          else { line.innerHTML = hi(text); setTimeout(nextLine, u.random(90, 260)); }
        })();
      }
      nextLine();
    }

    /* hold-to-enter: progress climbs while held, damps back to zero when you let go */
    function initHold() {
      var btn = one('[data-ill-hold]');
      if (!btn) return;
      var ring = btn.querySelector('[data-ill-ring]'), pct = btn.querySelector('[data-ill-pct]');
      var C = 2 * Math.PI * 54, holdMs = parseInt(root.getAttribute('data-hold'), 10) || 1400;
      var p = 0, holding = false, raf = 0, last = 0, buzzed = false, shakeT = 0;
      ring.style.strokeDasharray = C.toFixed(1);
      function paint() {
        ring.style.strokeDashoffset = u.mapRange(p, 0, 1, C, 0).toFixed(2);
        pct.textContent = pad(u.round(p * 100, 0), 3) + '%';
        if (!reduce && frame) {
          var k = p * p * 5;
          frame.style.transform = p > 0.02 ? 'translate(' + u.random(-k, k, 1) + 'px,' + u.random(-k, k, 1) + 'px)' : '';
          if (mark && p > 0.1) glitchVars(mark, 2 + p * 14);
        }
      }
      function loop(t) {
        var dt = Math.min(64, last ? t - last : 16); last = t;
        if (holding) p = u.clamp(p + dt / holdMs, 0, 1);
        else if (Date.now() - shakeT > 700) p = u.damp(p, 0, dt, 0.12); // shaking holds the charge
        paint();
        if (p >= 1) { raf = 0; holding = false; if (navigator.vibrate) navigator.vibrate([18, 40, 30]); breach(); return; }
        if (!holding && Date.now() - shakeT > 700 && p < 0.003) { p = 0; paint(); if (frame) frame.style.transform = ''; raf = 0; last = 0; btn.classList.remove('is-on'); return; }
        raf = requestAnimationFrame(loop);
      }
      function start(e) {
        if (entered) return;
        if (e && e.cancelable) e.preventDefault();
        holding = true; btn.classList.add('is-on');
        if (!buzzed && navigator.vibrate) { navigator.vibrate(10); buzzed = true; }
        if (!raf) { last = 0; raf = requestAnimationFrame(loop); }
      }
      function stop() { holding = false; buzzed = false; }
      btn.addEventListener('pointerdown', function (e) { try { btn.setPointerCapture(e.pointerId); } catch (x) { /* ignore */ } start(e); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { btn.addEventListener(ev, stop); });
      btn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      btn.addEventListener('keydown', function (e) { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); start(); } });
      btn.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') stop(); });
      btn.addEventListener('click', function (e) { e.preventDefault(); });
      paint();

      // Phones: shaking charges the ring too. The hint only appears once motion data actually arrives
      // (Android, or an iPhone that already allowed motion on the homepage).
      if (window.DeviceMotionEvent && mq('(pointer: coarse)')) {
        var hint = one('[data-ill-shake]'), lx = null, ly = 0, lz = 0;
        window.addEventListener('devicemotion', function (e) {
          var a = e.accelerationIncludingGravity || e.acceleration;
          if (!a || a.x == null || entered) return;
          if (hint && hint.hidden) hint.hidden = false;
          if (lx !== null) {
            var jolt = Math.abs(a.x - lx) + Math.abs(a.y - ly) + Math.abs(a.z - lz), now = Date.now();
            if (jolt > 22 && now - shakeT > 110) {
              shakeT = now;
              p = u.clamp(p + 0.22, 0, 1);
              btn.classList.add('is-on');
              if (navigator.vibrate) navigator.vibrate(8);
              if (!raf) { last = 0; raf = requestAnimationFrame(loop); }
            }
          }
          lx = a.x; ly = a.y; lz = a.z;
        }, { passive: true });
      }
    }

    /* access code: compared as a SHA-256 hash, so the code itself never sits in the page */
    function initPass() {
      var form = one('[data-ill-pass]');
      if (!form) return;
      var want = gate.getAttribute('data-pass'), msg = form.querySelector('[data-ill-msg]'), input = form.querySelector('input'), tries = 0;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = (input.value || '').trim().toLowerCase();
        if (!val) return;
        var check = window.crypto && window.crypto.subtle
          ? window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(val)).then(function (buf) {
              return Array.prototype.map.call(new Uint8Array(buf), function (b) { return u.padStart(b.toString(16), 2, '0'); }).join('');
            })
          : Promise.resolve('');
        check.then(function (got) {
          if (got && got === want) { msg.textContent = ''; breach(); return; }
          tries++;
          input.value = '';
          scramble(msg, 'ACCESS DENIED // ATTEMPT ' + pad(tries), { speed: 3 });
          if (navigator.vibrate) navigator.vibrate([30, 30, 30]);
          if (!reduce) A.animate(frame, { x: [0, -14, 12, -8, 6, 0], duration: 420, ease: 'outQuad', onComplete: function () { frame.style.transform = ''; } });
        });
      });
    }

    /* breach: the gate shatters into blocks that fall away from the centre */
    function breach(instant) {
      if (entered) return;
      entered = true;
      store.set();
      if (instant || reduce) { H.classList.add('ill-in'); document.body.classList.remove('ill-locked'); world(!!instant); return; }
      var vw = window.innerWidth, vh = window.innerHeight;
      var cols = vw < 700 ? 8 : 14, rows = Math.max(4, Math.round(cols * vh / vw));
      var grid = document.createElement('div');
      grid.className = 'ill-breach'; grid.setAttribute('aria-hidden', 'true');
      grid.style.gridTemplateColumns = 'repeat(' + cols + ',1fr)';
      grid.style.gridTemplateRows = 'repeat(' + rows + ',1fr)';
      var cells = [];
      for (var i = 0; i < cols * rows; i++) { var c = document.createElement('span'); cells.push(c); grid.appendChild(c); }
      u.shuffle(cells.slice()).slice(0, Math.round(cells.length * 0.22)).forEach(function (c, i) { c.className = i % 5 === 0 ? 'r' : 'a'; });
      u.set(cells, { opacity: 0 });
      document.body.appendChild(grid);
      A.animate(u.shuffle(cells.slice()), {
        opacity: 1, duration: 60, ease: 'linear', delay: A.stagger(3),
        onComplete: function () {
          H.classList.add('ill-in');
          document.body.classList.remove('ill-locked');
          window.scrollTo(0, 0);
          world(false);
          cells.forEach(function (c) { if (c.className === 'a' || c.className === 'r') c.className = ''; });
          A.animate(cells, {
            opacity: [1, 0], scale: [1, 0.2], duration: 520, ease: 'inQuad',
            delay: A.stagger(22, { grid: [rows, cols], from: 'center' }),
            onComplete: function () { grid.remove(); }
          });
        }
      });
    }

    /* ---------- the world ---------- */
    function world(skipIntro) {
      var lines = $('.ill-line__in', root);
      if (!reduce && !skipIntro) {
        var intro = A.animate(lines, { y: ['110%', '0%'], duration: 1100, delay: A.stagger(110, { start: 250 }), ease: 'outExpo', onComplete: function () { u.cleanInlineStyles(intro); } });
      }
      $('[data-ill-scramble]', root).forEach(function (el, i) { setTimeout(function () { scramble(el, null, { speed: 1, tick: 40 }); }, 200 + i * 120); });
      countTo(one('[data-ill-sector]'), u.snap(rnd(3, 99), 1), 2);
      var items = $('[data-ill-item]', root);
      countTo(one('[data-ill-items]'), items.length, 2);
      initItems(items);
      initGlitchLoop(lines);
      initFloor();
      initTicker();
      initMeterAndCursor();
      initManifesto();
      initBuy();
      initExit();
    }

    function countTo(el, n, len) {
      if (!el) return;
      if (reduce) { el.textContent = pad(n, len); return; }
      var o = { v: 0 };
      A.animate(o, { v: n, duration: 1200, ease: 'outExpo', delay: 300, onUpdate: function () { el.textContent = pad(u.round(o.v, 0), len); } });
    }

    /* headline: RGB-split glitch bursts at random intervals */
    function initGlitchLoop(lines) {
      if (reduce || !lines.length) return;
      (function burst() {
        var el = u.randomPick(lines), n = u.random(2, 4), i = 0;
        (function step() {
          if (i++ >= n) { el.classList.remove('is-glitch'); setTimeout(burst, u.random(1400, 4200)); return; }
          var a = u.random(0, 70), b = u.random(0, 70);
          el.style.setProperty('--gx', u.random(-12, 12) + 'px'); el.style.setProperty('--rx', u.random(-12, 12) + 'px');
          el.style.setProperty('--g1', a + '%'); el.style.setProperty('--g2', u.clamp(92 - a - u.random(5, 25), 0, 96) + '%');
          el.style.setProperty('--g3', b + '%'); el.style.setProperty('--g4', u.clamp(92 - b - u.random(5, 25), 0, 96) + '%');
          el.classList.add('is-glitch');
          setTimeout(step, u.random(50, 120));
        })();
      })();
    }

    /* hero floor: a perspective grid rushing toward you, a dead skyline on the horizon.
       Rays use degToRad; depth lines wrap; the vanishing point lerps toward the cursor. */
    function initFloor() {
      var cv = one('[data-ill-floor]');
      if (!cv) return;
      var ctx = cv.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1);
      var w = 0, h = 0, z = 0, last = 0, vx = 0.5, tx = 0.5, visible = true, towers = [];
      var acid = getComputedStyle(root).getPropertyValue('--ill-acid').trim() || '#D4FF3A';
      var city = u.createSeededRandom(1337);
      for (var i = 0; i < 46; i++) towers.push({ x: i / 46, w: city(8, 26) / 1000, h: city(20, 140) / 1000, lit: city(0, 100) });
      function size() {
        var r = cv.getBoundingClientRect(); w = r.width; h = r.height;
        cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function frame(t) {
        requestAnimationFrame(frame);
        if (!visible || document.hidden) { last = t; return; }
        var dt = Math.min(64, last ? t - last : 16); last = t;
        z = u.wrap(z + (reduce ? 0 : dt * 0.00032), 0, 1);
        vx = u.lerp(vx, tx, 0.04);
        ctx.clearRect(0, 0, w, h);
        var hz = h * 0.56, cx = w * vx;
        // skyline
        ctx.fillStyle = '#0B0C09';
        towers.forEach(function (tw) {
          var bh = tw.h * h * 1.6, bx = tw.x * w * 1.1 - w * 0.05;
          ctx.fillRect(bx, hz - bh, tw.w * w, bh);
          if (tw.lit > 72 && Math.random() > 0.02) { ctx.fillStyle = tw.lit > 94 ? 'rgba(255,46,77,.8)' : 'rgba(212,255,58,.55)'; ctx.fillRect(bx + 3, hz - bh + 6, 2, 2); ctx.fillStyle = '#0B0C09'; }
        });
        // horizon glow
        var g = ctx.createLinearGradient(0, hz - 60, 0, hz + 10);
        g.addColorStop(0, 'rgba(212,255,58,0)'); g.addColorStop(1, 'rgba(212,255,58,.16)');
        ctx.fillStyle = g; ctx.fillRect(0, hz - 60, w, 70);
        // rays
        ctx.strokeStyle = acid; ctx.lineWidth = 1;
        for (var a = -84; a <= 84; a += 7) {
          var rad = u.degToRad(a), len = h * 2;
          ctx.globalAlpha = u.mapRange(Math.abs(a), 0, 84, 0.34, 0.08);
          ctx.beginPath(); ctx.moveTo(cx, hz); ctx.lineTo(cx + Math.sin(rad) * len, hz + Math.cos(rad) * len); ctx.stroke();
        }
        // depth lines
        for (var k = 0; k < 18; k++) {
          var d = (k + z) / 18, y = hz + Math.pow(d, 2.4) * (h - hz) * 1.05;
          ctx.globalAlpha = u.clamp(d * 0.9, 0.04, 0.6);
          ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }
      size();
      window.addEventListener('resize', size);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(cv);
      window.addEventListener('pointermove', function (e) { tx = u.clamp(u.mapRange(e.clientX, 0, window.innerWidth, 0.3, 0.7), 0.3, 0.7); }, { passive: true });
      requestAnimationFrame(frame);
    }

    /* ticker: wrap() makes the loop seamless; scrolling fast pushes it harder */
    var scrollVel = 0, lastY = window.scrollY;
    window.addEventListener('scroll', function () { var y = window.scrollY; scrollVel = u.clamp(scrollVel + Math.abs(y - lastY), 0, 400); lastY = y; }, { passive: true });
    function initTicker() {
      var tr = one('[data-ill-ticker]');
      if (!tr || reduce) return;
      var x = 0, last = 0, boost = 0;
      (function tick(t) {
        requestAnimationFrame(tick);
        var dt = Math.min(64, last ? t - last : 16); last = t;
        var half = tr.scrollWidth / 2;
        boost = u.damp(boost, scrollVel, dt, 0.08);
        x = u.wrap(x - (70 + boost * 3) * dt / 1000, -half, 0);
        tr.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      })(0);
    }

    /* signal meter + crosshair cursor with a padded X/Y readout */
    function initMeterAndCursor() {
      var bars = $('.ill-meter i', root), cur = one('[data-ill-cursor]'), xy = one('[data-ill-xy]');
      var lab = cur && cur.querySelector('b');
      var mx = window.innerWidth / 2, my = window.innerHeight / 2, px = mx, py = my, energy = 0, last = 0, hot = false;
      window.addEventListener('pointermove', function (e) {
        energy = u.clamp(energy + Math.hypot(e.clientX - mx, e.clientY - my) * 0.8, 0, 220);
        mx = e.clientX; my = e.clientY;
        var h2 = !!(e.target.closest && e.target.closest('a, button, select, input, label'));
        if (h2 !== hot && cur) { hot = h2; cur.classList.toggle('is-hot', hot); }
      }, { passive: true });
      (function loop(t) {
        requestAnimationFrame(loop);
        var dt = Math.min(64, last ? t - last : 16); last = t;
        energy = u.damp(energy, 0, dt, 0.05);
        scrollVel = u.damp(scrollVel, 0, dt, 0.06);
        var e = u.clamp(u.mapRange(energy + scrollVel, 0, 260, 0.15, 1), 0.15, 1);
        bars.forEach(function (b, i) {
          var target = reduce ? 0.6 : u.clamp(e * u.mapRange(i, 0, bars.length - 1, 0.55, 1) + u.random(-0.12, 0.12, 2), 0.1, 1);
          b.style.transform = 'scaleY(' + target.toFixed(2) + ')';
        });
        if (cur && fine) {
          px = u.lerp(px, mx, reduce ? 1 : 0.32); py = u.lerp(py, my, reduce ? 1 : 0.32);
          cur.style.transform = 'translate3d(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px,0)';
          if (lab) lab.textContent = 'X:' + pad(Math.round(mx), 4) + ' Y:' + pad(Math.round(my), 4);
        }
        if (xy && (t | 0) % 3 === 0) xy.textContent = 'X:' + pad(Math.round(mx), 4) + ' Y:' + pad(Math.round(my + window.scrollY), 5);
      })(0);
    }

    /* manifest: items ripple in from the centre; each gets a seeded ID; hover tears the photo */
    function initItems(items) {
      if (!items.length) return;
      var gridEl = one('[data-ill-grid]');
      items.forEach(function (it, i) {
        var id = parseInt(it.getAttribute('data-id'), 10) || i + 1;
        var r = u.createSeededRandom(id % 2147483647);
        var tag = it.querySelector('[data-ill-id]');
        if (tag) tag.setAttribute('data-final', '#' + pad(i + 1, 4) + ' // ' + hex(r(0, 65535)));
      });
      var reveal = function () {
        items.forEach(function (it, i) {
          var tag = it.querySelector('[data-ill-id]');
          if (tag) setTimeout(function () { scramble(tag, tag.getAttribute('data-final'), { speed: 1, tick: 36 }); }, 150 + i * 40);
        });
        if (reduce) return;
        var tops = [];
        items.forEach(function (n) { var t = Math.round(n.offsetTop); if (tops.indexOf(t) < 0) tops.push(t); });
        var rows = Math.max(1, tops.length), cols = Math.max(1, Math.ceil(items.length / rows));
        A.animate(items, {
          opacity: [0, 1], y: [40, 0], scale: [0.94, 1],
          rotate: { from: function () { return u.random(-3, 3, 1); }, to: 0 },
          duration: 900, ease: 'outExpo',
          delay: A.stagger(70, { grid: [rows, cols], from: 'center' }),
          onComplete: function () { items.forEach(function (n) { n.style.opacity = ''; n.style.transform = ''; }); }
        });
      };
      if (!reduce) u.set(items, { opacity: 0 });
      if ('IntersectionObserver' in window && gridEl) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); reveal(); } }, { threshold: 0.08 });
        io.observe(gridEl);
      } else reveal();

      if (reduce || !fine) return;
      items.forEach(function (it) {
        var media = it.querySelector('.ill-item__media'), img = media && media.querySelector('img');
        if (!media || !img) return;
        media.addEventListener('pointerenter', function () {
          var src = img.currentSrc || img.src;
          for (var k = 0; k < 3; k++) {
            var sl = document.createElement('span');
            sl.className = 'ill-item__slice';
            var top = u.random(5, 85), hh = u.random(3, 12);
            sl.style.cssText = 'inset:0;background-image:url("' + src + '");background-size:cover;clip-path:inset(' + top + '% 0 ' + u.clamp(100 - top - hh, 0, 100) + '% 0);';
            media.appendChild(sl);
            A.animate(sl, {
              x: [u.random(-18, 18), u.random(-6, 6), 0], opacity: [1, 0.8, 0],
              duration: u.random(180, 320), ease: 'outQuad',
              onComplete: (function (el) { return function () { el.remove(); }; })(sl)
            });
          }
        });
      });
    }

    /* manifesto: each line's letters resolve in shuffled order, flashing signal-color first */
    function initManifesto() {
      $('[data-ill-decrypt]', root).forEach(function (line) {
        if (reduce) return;
        var text = line.textContent, finalColor = u.get(line, 'color');
        line.setAttribute('aria-label', text);
        line.innerHTML = '';
        var chars = [];
        text.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { line.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span'); w.className = 'ill-dw'; w.setAttribute('aria-hidden', 'true');
          part.split('').forEach(function (ch) { var s = document.createElement('span'); s.className = 'ill-dc'; s.textContent = ch; chars.push(s); w.appendChild(s); });
          line.appendChild(w);
        });
        u.set(chars, { opacity: 0 });
        var acid = getComputedStyle(root).getPropertyValue('--ill-acid').trim() || '#D4FF3A';
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          A.animate(u.shuffle(chars.slice()), {
            opacity: [0, 1], color: [acid, finalColor], duration: 420, ease: 'outQuad',
            delay: A.stagger(u.clamp(Math.round(900 / chars.length), 8, 30)),
            onComplete: function () { line.textContent = text; line.removeAttribute('aria-label'); }
          });
        }, { threshold: 0.6 });
        io.observe(line);
      });
    }

    /* add to cart without leaving the underground */
    function initBuy() {
      var count = one('[data-ill-count]');
      var routes = window.illRoutes || { cartAdd: '/cart/add', cart: '/cart' };
      $('[data-ill-buy]', root).forEach(function (form) {
        var btn = form.querySelector('[data-ill-acquire]'), label = btn && btn.querySelector('span');
        var status = form.parentNode.querySelector('[data-ill-status]'), base = label ? label.textContent : '';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (btn.disabled) return;
          btn.disabled = true; btn.classList.remove('is-err');
          scramble(label, 'UPLINK…', { speed: 2 });
          var sel = form.querySelector('select'), vName = sel ? sel.options[sel.selectedIndex].text : '';
          fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
            .then(function () { return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
            .then(function (cart) {
              btn.disabled = false; btn.classList.add('is-done');
              scramble(label, 'ACQUIRED ✓', { speed: 2 });
              if (status) status.textContent = 'ADDED TO PAYLOAD' + (vName ? ' // ' + vName : '');
              if (navigator.vibrate) navigator.vibrate(14);
              if (count) {
                count.textContent = pad(cart.item_count);
                if (!reduce) A.animate(count.parentNode, { scale: [1, 1.18, 1], duration: 420, ease: 'outBack' });
              }
              setTimeout(function () { btn.classList.remove('is-done'); scramble(label, base, { speed: 2 }); }, 2400);
            })
            .catch(function (err) {
              btn.disabled = false; btn.classList.add('is-err');
              scramble(label, 'DENIED', { speed: 2 });
              if (status) status.textContent = String((err && (err.description || err.message)) || 'Transmission failed. Try again.').toUpperCase();
              setTimeout(function () { btn.classList.remove('is-err'); scramble(label, base, { speed: 2 }); }, 2800);
            });
        });
      });
    }

    /* leaving: the world glitches out before you surface */
    function initExit() {
      $('[data-ill-exit]', root).forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (reduce || e.metaKey || e.ctrlKey) return;
          e.preventDefault();
          var el = document.createElement('div'); el.className = 'ill-breach'; el.setAttribute('aria-hidden', 'true');
          var cols = 10, rows = 6, cells = [];
          el.style.gridTemplateColumns = 'repeat(' + cols + ',1fr)'; el.style.gridTemplateRows = 'repeat(' + rows + ',1fr)';
          for (var i = 0; i < cols * rows; i++) { var c = document.createElement('span'); cells.push(c); el.appendChild(c); }
          u.set(cells, { opacity: 0 });
          document.body.appendChild(el);
          A.animate(cells, { opacity: 1, duration: 80, delay: A.stagger(12, { grid: [rows, cols], from: 'random' }), onComplete: function () { window.location.href = a.href; } });
        });
      });
    }

    /* ---------- start ---------- */
    if (designMode || store.get() || !gate) {
      breach(true); // editing in Shopify, or already inside this visit: skip the gate
    } else {
      document.body.classList.add('ill-locked');
      typeLog();
      idleGlitch();
      initHold();
      initPass();
      var focusTarget = one('[data-ill-hold]') || (one('[data-ill-pass]') && one('[data-ill-pass] input'));
      if (focusTarget && fine) setTimeout(function () { try { focusTarget.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 400);
    }
  });
})();
